import React from "react";
import { Link } from "react-router-dom";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/lib/shadcn/ui/dropdown-menu";
import { Avatar, AvatarFallback, AvatarImage } from "@/lib/shadcn/ui/avatar";
import { LogOutIcon, SettingsIcon } from "lucide-react";

const defaultProfileImage = "https://p7.hiclipart.com/preview/442/477/305/computer-icons-user-profile-avatar-profile.jpg";

interface ProfileDropdownProps {
    profileImageUrl?: string;
    userName: string;
    isAdmin?: boolean;
}

const ProfileDropdown: React.FC<ProfileDropdownProps> = ({ profileImageUrl = defaultProfileImage, userName, isAdmin = false }) => {
    return (
        <DropdownMenu>
            <DropdownMenuTrigger className="flex items-center space-x-2 hover:opacity-80">
                <Avatar className="h-8 w-8">
                    <AvatarImage src={profileImageUrl} alt={userName} />
                    <AvatarFallback>{userName[0]}</AvatarFallback>
                </Avatar>
                <span className="text-sm hidden md:inline-block">{userName}</span>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-48">
                {isAdmin && (
                    <DropdownMenuItem asChild>
                        <Link to="/admin/settings" className="flex items-center">
                            <SettingsIcon className="mr-2 h-4 w-4" />
                            <span>Settings</span>
                        </Link>
                    </DropdownMenuItem>
                )}
                <DropdownMenuItem asChild>
                    <Link to="/logout" className="flex items-center">
                        <LogOutIcon className="mr-2 h-4 w-4 text-destructive" />
                        <span>Logout</span>
                    </Link>
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
};

export default ProfileDropdown;
